import reducer from "./reducer";
export { default as ThirdPartyClassification } from "./components/index";
export { default as thirdPartyClassificationReducerName } from "./constants";
export default reducer;
